import { useAuthSession } from '@/entities/auth/api/hooks';
import { useAccessMatrix } from '@/entities/admin/api/hooks';
import { getModuleAccess, canView, canEdit, isReadOnly, canAccessRoute } from './permissions';
import type { AccessLevel } from './permissions';

export function usePermission(module: string) {
  const { data: session } = useAuthSession();
  const { data: matrix } = useAccessMatrix();
  const role = session?.user.role;

  return {
    access: getModuleAccess(matrix, role, module) as AccessLevel,
    canView: canView(matrix, role, module),
    canEdit: canEdit(matrix, role, module),
    isReadOnly: isReadOnly(matrix, role, module),
    role,
  };
}

export function useRouteAccess(routeKey: string) {
  const { data: session } = useAuthSession();
  const { data: matrix } = useAccessMatrix();
  const role = session?.user.role;

  return canAccessRoute(matrix, role, routeKey);
}
